<div class="sub-headline" [class.expanded]="expanded">
  <span class="label" *ngIf="subHeadline && !tooltipText">{{ subHeadline }}</span>
  <pf-title-with-tooltip  *ngIf="subHeadline && tooltipText" [label]="subHeadline" tooltipPosition="above"
                          [tooltip]="tooltipText"></pf-title-with-tooltip>
  <span class="status" *ngIf="statusLabel" [ngClass]="statusColor">{{ statusLabel }}</span>
</div>
